/***
 *
 *   DETAILS
 *   The small pieces the step cards, the drawer and the account panels share:
 *   a definition list of detail rows (counts pop over), a Settings link, and
 *   the public link box with its Preview.
 *
 *   Settings links are in-app paths the server has already filtered by role,
 *   so they route with Link. Public links are paths too; the full URL is
 *   built here from window.location.origin.
 *
 **********/

import React from "react";
import { Icon, Link } from "components/lib";
import { CountPopover } from "./popover";
import styles from "./workflow.module.scss";

export const cx = (...names) => names.filter(Boolean).join(" ");

/* a step's body as a sentence, for the start card's drawer */
export const sentence = (text) => (!text || /[.!?]$/.test(text) ? text : `${text}.`);

export function DetailList({ rows, className }) {
  if (!Array.isArray(rows) || !rows.length) return null;

  return (
    <dl className={className}>
      {rows.map((row, i) => (
        <React.Fragment key={`${row.label}-${i}`}>
          <dt>{row.label}</dt>
          <dd>{row.popover ? <CountPopover value={row.value} popover={row.popover} /> : row.value}</dd>
        </React.Fragment>
      ))}
    </dl>
  );
}

export function SettingsLink({ settings }) {
  if (!settings?.path) return null;

  return (
    <Link url={settings.path} className={styles.slink}>
      <Icon image="settings" size={12} />
      {settings.label || "Settings"}
    </Link>
  );
}

export function PublicLinkBox({ link }) {
  if (!link?.path) return null;
  const url = `${window.location.origin}${link.path}`;

  return (
    <div className={styles.purl}>
      <small>Public link</small>
      <code>{url}</code>
      <div className={styles.purlRow}>
        <a className={styles.pbtn} href={url} target="_blank" rel="noopener noreferrer">
          Preview
        </a>
      </div>
      {link.note && <p className={styles.purlNote}>{link.note}</p>}
    </div>
  );
}
